import ReactDOM from 'react-dom';
import {
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewChild,
    ViewEncapsulation,
} from '@angular/core';
import { Store } from '@ngxs/store';
import {
    Environment,
    SosAuthorizationService,
    SosCoreConfig,
} from '@serviceos-ng/core';
import React from 'react';

import { TipModuleComponentFactory } from '@serviceos-rn/tip';
import { TipProModule } from '../tip-pro.module';
import { Application } from '@serviceos-rn/core';


@Component({
    selector: 'serviceos-web-tip-pro',
    templateUrl: './tip-pro.component.html',
    styleUrls: ['./tip-pro.component.scss'],
    encapsulation: ViewEncapsulation.Emulated
})
export class TipProComponent implements OnInit {
    @ViewChild('reactModuleTipPro', { static: false })
    public reactModuleContainer!: ElementRef;
    rootComponent: any;

    @Output()
    tipEvent: EventEmitter<any> = new EventEmitter();

    @Input()
    bookingId: string | number | undefined;

    @Input()
    position: string | undefined;


    constructor(
        private store: Store,
        private authService: SosAuthorizationService,
        private env: Environment,
        private config: SosCoreConfig
    ) {}

    ngOnInit(): void {
        const sid: string = this.authService.checkAuthorization() || '',

        params = {
            payload: {
                  booking_id: this.bookingId,
                  position: this.position,
                  integrated: true
            },
            state: {
                sid,
                profile_keyword: this.config.profile_id,
                configuration: {
                    application: {
                        settings: {
                            api_url: this.config.api_url,
                            application_token: this.config.key,
                            namespace: 'client',
                            debug: !this.env.production
                        }
                    },
                },
            },
            onEvent: (event: { data: any; event: string; module: string }) => {
                if (!this.env.production) {
                    console.warn('tipEvent', event);
                }
                this.tipEvent.emit(event);
            },
        };

        Application.onError.subscribe(console.debug)

        this.rootComponent = TipModuleComponentFactory.create(params);
        this.render();
    }

    ngOnChanges(): void {
        this.render();
    }

    ngAfterViewInit(): void {
        this.render();
    }

    ngOnDestroy(): void {
        if (this.rootComponent) {
            ReactDOM.unmountComponentAtNode(
                this.reactModuleContainer.nativeElement
            );
        }
    }

    private render() {
        if (this.rootComponent && this.reactModuleContainer?.nativeElement) {
            ReactDOM.render(
                React.createElement(this.rootComponent),
                this.reactModuleContainer.nativeElement
            );
        }
    }
}
